// @flow
export const FORM_REDUX_NAME = 'QuickPromoteForm';

export const ONE_MILLION = 1000000;
export const ONE_DOLLAR = ONE_MILLION;
export const ONE_CENT = ONE_DOLLAR / 100;
export const DEFAULT_SYMBOL = 'US';
export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_CURRENCY_SYMBOL_VALUE = '$';

export const AT_COUNTRY_SYMBOL = 'AT';
export const AT_CURRENCY_NAME = 'EUR';
export const AT_CURRENCY_SYMBOL_VALUE = '€';

export const AU_COUNTRY_SYMBOL = 'AU';
export const AU_CURRENCY_NAME = 'AUD';
export const AU_CURRENCY_SYMBOL_VALUE = '$';

export const BE_COUNTRY_SYMBOL = 'BE';
export const BE_CURRENCY_NAME = 'EUR';
export const BE_CURRENCY_SYMBOL_VALUE = '€';

export const CA_COUNTRY_SYMBOL = 'CA';
export const CA_CURRENCY_NAME = 'CAD';
export const CA_CURRENCY_SYMBOL_VALUE = '$';

export const CH_COUNTRY_SYMBOL = 'CH';
export const CH_CURRENCY_NAME = 'CHF';
export const CH_CURRENCY_SYMBOL_VALUE = 'CHF';

export const DE_COUNTRY_SYMBOL = 'DE';
export const DE_CURRENCY_NAME = 'EUR';
export const DE_CURRENCY_SYMBOL_VALUE = '€';

export const DK_COUNTRY_SYMBOL = 'DK';
export const DK_CURRENCY_NAME = 'DKK';
export const DK_CURRENCY_SYMBOL_VALUE = 'kr';

export const ES_COUNTRY_SYMBOL = 'ES';
export const ES_CURRENCY_NAME = 'EUR';
export const ES_CURRENCY_SYMBOL_VALUE = '€';

export const FI_COUNTRY_SYMBOL = 'FI';
export const FI_CURRENCY_NAME = 'EUR';
export const FI_CURRENCY_SYMBOL_VALUE = '€';

export const FR_COUNTRY_SYMBOL = 'FR';
export const FR_CURRENCY_NAME = 'EUR';
export const FR_CURRENCY_SYMBOL_VALUE = '€';

export const GB_COUNTRY_SYMBOL = 'GB';
export const GB_CURRENCY_NAME = 'GBP';
export const GB_CURRENCY_SYMBOL_VALUE = '£';

export const IE_COUNTRY_SYMBOL = 'IE';
export const IE_CURRENCY_NAME = 'EUR';
export const IE_CURRENCY_SYMBOL_VALUE = '€';

export const IT_COUNTRY_SYMBOL = 'IT';
export const IT_CURRENCY_NAME = 'EUR';
export const IT_CURRENCY_SYMBOL_VALUE = '€';

export const NL_COUNTRY_SYMBOL = 'NL';
export const NL_CURRENCY_NAME = 'EUR';
export const NL_CURRENCY_SYMBOL_VALUE = '€';

export const NO_COUNTRY_SYMBOL = 'NO';
export const NO_CURRENCY_NAME = 'NOK';
export const NO_CURRENCY_SYMBOL_VALUE = 'kr';

export const NZ_COUNTRY_SYMBOL = 'NZ';
export const NZ_CURRENCY_NAME = 'NZD';
export const NZ_CURRENCY_SYMBOL_VALUE = '$';

export const PT_COUNTRY_SYMBOL = 'PT';
export const PT_CURRENCY_NAME = 'EUR';
export const PT_CURRENCY_SYMBOL_VALUE = '€';

export const SE_COUNTRY_SYMBOL = 'SE';
export const SE_CURRENCY_NAME = 'SEK';
export const SE_CURRENCY_SYMBOL_VALUE = 'kr';

// The default number of days to run a quick promote campaign
// Stored here as a string to normalize code paths and allow for blank values (not NaN) in the input field
export const DEFAULT_DURATION = '30';
export const MIN_DURATION = 1; // days
export const MAX_DURATION = 365; // days
export const DEFAULT_ONGOING = false;
export const MAX_NAME_LENGTH = 64; // Max campaign name length
export const MIN_BUDGET_IN_MICROCURRENCY = 1 * ONE_DOLLAR; // Minimum budget amount in micro currency
export const MIN_BUDGET_MICROCURRENCY_RESOLUTION = 10000; // Minimum resolution for the budget once microcurrency
export const MAX_BUDGET_IN_MICROCURRENCY = 100000 * ONE_DOLLAR; // Maximum budget amount in micro currency

export function currencyInfo(country: string) {
  let currencyName = DEFAULT_CURRENCY;
  let currencySymbolValue = DEFAULT_CURRENCY_SYMBOL_VALUE;
  switch (country) {
    case AT_COUNTRY_SYMBOL:
      currencyName = AT_CURRENCY_NAME;
      currencySymbolValue = AT_CURRENCY_SYMBOL_VALUE;
      break;
    case AU_COUNTRY_SYMBOL:
      currencyName = AU_CURRENCY_NAME;
      currencySymbolValue = AU_CURRENCY_SYMBOL_VALUE;
      break;
    case BE_COUNTRY_SYMBOL:
      currencyName = BE_CURRENCY_NAME;
      currencySymbolValue = BE_CURRENCY_SYMBOL_VALUE;
      break;
    case CA_COUNTRY_SYMBOL:
      currencyName = CA_CURRENCY_NAME;
      currencySymbolValue = CA_CURRENCY_SYMBOL_VALUE;
      break;
    case CH_COUNTRY_SYMBOL:
      currencyName = CH_CURRENCY_NAME;
      currencySymbolValue = CH_CURRENCY_SYMBOL_VALUE;
      break;
    case DE_COUNTRY_SYMBOL:
      currencyName = DE_CURRENCY_NAME;
      currencySymbolValue = DE_CURRENCY_SYMBOL_VALUE;
      break;
    case DK_COUNTRY_SYMBOL:
      currencyName = DK_CURRENCY_NAME;
      currencySymbolValue = DK_CURRENCY_SYMBOL_VALUE;
      break;
    case ES_COUNTRY_SYMBOL:
      currencyName = ES_CURRENCY_NAME;
      currencySymbolValue = ES_CURRENCY_SYMBOL_VALUE;
      break;
    case FI_COUNTRY_SYMBOL:
      currencyName = FI_CURRENCY_NAME;
      currencySymbolValue = FI_CURRENCY_SYMBOL_VALUE;
      break;
    case FR_COUNTRY_SYMBOL:
      currencyName = FR_CURRENCY_NAME;
      currencySymbolValue = FR_CURRENCY_SYMBOL_VALUE;
      break;
    case GB_COUNTRY_SYMBOL:
      currencyName = GB_CURRENCY_NAME;
      currencySymbolValue = GB_CURRENCY_SYMBOL_VALUE;
      break;
    case IE_COUNTRY_SYMBOL:
      currencyName = IE_CURRENCY_NAME;
      currencySymbolValue = IE_CURRENCY_SYMBOL_VALUE;
      break;
    case IT_COUNTRY_SYMBOL:
      currencyName = IT_CURRENCY_NAME;
      currencySymbolValue = IT_CURRENCY_SYMBOL_VALUE;
      break;
    case NL_COUNTRY_SYMBOL:
      currencyName = NL_CURRENCY_NAME;
      currencySymbolValue = NL_CURRENCY_SYMBOL_VALUE;
      break;
    case NO_COUNTRY_SYMBOL:
      currencyName = NO_CURRENCY_NAME;
      currencySymbolValue = NO_CURRENCY_SYMBOL_VALUE;
      break;
    case NZ_COUNTRY_SYMBOL:
      currencyName = NZ_CURRENCY_NAME;
      currencySymbolValue = NZ_CURRENCY_SYMBOL_VALUE;
      break;
    case PT_COUNTRY_SYMBOL:
      currencyName = PT_CURRENCY_NAME;
      currencySymbolValue = PT_CURRENCY_SYMBOL_VALUE;
      break;
    case SE_COUNTRY_SYMBOL:
      currencyName = SE_CURRENCY_NAME;
      currencySymbolValue = SE_CURRENCY_SYMBOL_VALUE;
      break;
    default:
      break;
  }
  return [currencyName, currencySymbolValue];
}

// Below constants are used for smb_qp_modify_budget_has_billing_int experiment
export const QP_COUNTRY_BUDGET_MED = {
  AU: { budget: 3, duration: '10' },
  CA: { budget: 3, duration: '10' },
  FR: { budget: 3, duration: '10' },
  GB: { budget: 3, duration: '10' },
  IE: { budget: 3, duration: '10' },
  NZ: { budget: 3, duration: '10' },
  US: { budget: 3, duration: '10' },
  AT: { budget: 3, duration: '10' },
  DE: { budget: 3, duration: '10' },
  IT: { budget: 3, duration: '10' },
  ES: { budget: 3, duration: '10' },
  NL: { budget: 3, duration: '10' },
  PT: { budget: 3, duration: '10' },
  BE: { budget: 3, duration: '10' },
  CH: { budget: 3, duration: '10' },
  SE: { budget: 10, duration: '30' },
  NO: { budget: 10, duration: '30' },
  DK: { budget: 10, duration: '30' },
  FI: { budget: 3, duration: '10' },
};

export const QP_COUNTRY_BUDGET_INT = {
  AU: { budget: 1, duration: '10' },
  CA: { budget: 1, duration: '10' },
  FR: { budget: 1, duration: '10' },
  GB: { budget: 1, duration: '10' },
  IE: { budget: 1, duration: '10' },
  NZ: { budget: 1, duration: '10' },
  US: { budget: 1, duration: '10' },
  AT: { budget: 1, duration: '10' },
  DE: { budget: 1, duration: '10' },
  IT: { budget: 1, duration: '10' },
  ES: { budget: 1, duration: '10' },
  NL: { budget: 1, duration: '10' },
  PT: { budget: 1, duration: '10' },
  BE: { budget: 1, duration: '10' },
  CH: { budget: 1, duration: '10' },
  SE: { budget: 10, duration: '30' },
  NO: { budget: 10, duration: '30' },
  DK: { budget: 10, duration: '30' },
  FI: { budget: 1, duration: '10' },
};

export const QP_COUNTRY_BUDGET_AVG = {
  AU: { budget: 9, duration: '10' },
  CA: { budget: 8, duration: '10' },
  FR: { budget: 8, duration: '10' },
  GB: { budget: 5, duration: '10' },
  IE: { budget: 8, duration: '10' },
  NZ: { budget: 9, duration: '10' },
  US: { budget: 8, duration: '10' },
  AT: { budget: 8, duration: '10' },
  DE: { budget: 8, duration: '10' },
  IT: { budget: 8, duration: '10' },
  ES: { budget: 8, duration: '10' },
  NL: { budget: 8, duration: '10' },
  PT: { budget: 8, duration: '10' },
  BE: { budget: 8, duration: '10' },
  CH: { budget: 8, duration: '10' },
  SE: { budget: 10, duration: '30' },
  NO: { budget: 10, duration: '30' },
  DK: { budget: 10, duration: '30' },
  FI: { budget: 8, duration: '10' },
};

export const QUICK_PROMOTE_MODAL = {
  PIN_SELECTION_MODAL: 'PIN_SELECTION_MODAL',
  PROMOTE_FORM: 'QUICK_PROMOTE_FORM',
  BUSINESS_FORM: 'QUICK_PROMOTE_BUSINESS_FORM',
  BILLING_FORM: 'QUICK_PROMOTE_BILLING_FORM',
  SUCCESS_MODAL: 'SUCCESS_MODAL',
};

export const QUICK_PROMOTE_PAGE = 'QUICK_PROMOTE_PAGE';

// Keep the order of the steps
export const QUICK_PROMOTE_SCREENS = [
  QUICK_PROMOTE_MODAL.PIN_SELECTION_MODAL,
  QUICK_PROMOTE_MODAL.PROMOTE_FORM,
  QUICK_PROMOTE_PAGE,
  QUICK_PROMOTE_MODAL.BUSINESS_FORM,
  QUICK_PROMOTE_MODAL.BILLING_FORM,
  QUICK_PROMOTE_MODAL.SUCCESS_MODAL,
];

export type QuickPromoteScreenType = $Values<typeof QUICK_PROMOTE_MODAL>;
